import type { I_It4CheckImei, I_It4CheckImei_Return } from "./it4CheckImei.types.js";

import axios from "../configRequest.js";
import { I_AXIOS } from "../configRequest.model.js";

export const it4CheckImei: I_It4CheckImei = async (payload) => {
    const photoSetData = await axios.post<I_It4CheckImei_Return["data"]>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/um/oplc/imei?session=${payload.session}&imei=${payload.imei}`,
        {
            headers: {
                Accept: "application/json;charset=UTF-8",
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
    );
    return photoSetData.data;
};

export default it4CheckImei;
